import type { FC } from 'react';

import { SETTINGS_NAV } from '@/features/settings/constants';
import type { SettingsTab } from '@/types/settings.types';
import { cn } from '@/utils/cn.util';

interface SettingsNavProps {
  tab: SettingsTab;
  /** Admin Roles is super_admin-only; it is hidden entirely for everyone else. */
  showAdmins: boolean;
  onChangeTab: (tab: SettingsTab) => void;
}

/** Ports the prototype's `.settings-nav`: 240px column, 8px padding, 10px/14px rounded items. */
const SettingsNav: FC<SettingsNavProps> = ({ tab, showAdmins, onChangeTab }) => (
  <nav className="rounded-2xl border border-[var(--color-divider)] bg-white p-2 shadow-[var(--shadow-card)]">
    {SETTINGS_NAV.filter((item) => item.key !== 'admins' || showAdmins).map((item) => (
      <button
        key={item.key}
        type="button"
        onClick={() => onChangeTab(item.key)}
        className={cn(
          'w-full rounded-lg px-3.5 py-2.5 text-left text-[13px] font-medium text-[var(--color-ink-muted)] transition-colors',
          'hover:bg-[var(--color-brand-50)] hover:font-semibold hover:text-brand-600',
          tab === item.key && 'bg-[var(--color-brand-50)] font-semibold text-brand-600',
        )}
      >
        {item.label}
      </button>
    ))}
  </nav>
);

export default SettingsNav;
